/**
 * Хранилище черновика автоматического распознавания стен по подложке БТИ.
 *
 * Позволяет видеть найденные стены на 2D-холсте поверх подложки, крутить чувствительность,
 * кликом на холсте отключать лишние отрезки (или возвращать их) и применить результат
 * одним шагом истории.
 */
import { create } from "zustand";
import { useUnderlayStore } from "@/shared/store/layers";
import type { RecognizedWall } from "./recognizedWalls";

interface UnderlayRecognitionState {
	/** Список распознанных кандидатов в стены (пустой, когда превью закрыто) */
	walls: RecognizedWall[];
	/** Идёт ли сейчас расчёт в Web Worker */
	running: boolean;
	/** Чувствительность бинаризации (15..85) */
	sensitivity: number;
	/** Замыкать ли проёмы и автоматически ставить в них двери и окна */
	includeOpenings: boolean;

	setWalls: (walls: RecognizedWall[]) => void;
	setRunning: (running: boolean) => void;
	setSensitivity: (sensitivity: number) => void;
	setIncludeOpenings: (includeOpenings: boolean) => void;
	toggleWall: (id: string) => void;
	clear: () => void;
}

export const useUnderlayRecognitionStore = create<UnderlayRecognitionState>((set) => ({
	walls: [],
	running: false,
	sensitivity: 50,
	includeOpenings: false,

	setWalls: (walls) => set({ walls }),
	setRunning: (running) => set({ running }),
	setSensitivity: (sensitivity) => set({ sensitivity }),
	setIncludeOpenings: (includeOpenings) => set({ includeOpenings }),
	toggleWall: (id) =>
		set((state) => ({
			walls: state.walls.map((w) => (w.id === id ? { ...w, enabled: !w.enabled } : w)),
		})),
	clear: () => set({ walls: [], running: false }),
}));

// Если подложку убрали (например, при «Сбросить чертёж» или смене проекта) — сбрасываем превью стен
useUnderlayStore.subscribe((state, prevState) => {
	if (!state.image && prevState.image) {
		useUnderlayRecognitionStore.getState().clear();
	}
});
